module.exports = __webpack_public_path__ + "img/hero_portrait_wizard_female.eb3d0836.png";